import { getQaSelector } from '../../../utils/common'
import { Input as InputComponent, InputMode } from '../../Input'

import { CURRENCY_AMOUNT_INPUT_NAME } from './CurrencyAmountInput.constants'

function CurrencyAmountInput({
  Input = InputComponent,
  inputProps,
  inputRef,
  inputValue,
  placeholder,
  qaName,
  onChange,
}) {
  return (
    <Input
      {...inputProps}
      {...getQaSelector({ value: qaName })}
      inputMode={InputMode.Decimal}
      name={CURRENCY_AMOUNT_INPUT_NAME}
      placeholder={placeholder}
      ref={inputRef}
      value={inputValue}
      onChange={onChange}
    />
  )
}

export default CurrencyAmountInput
